import { useInfiniteQuery } from '@tanstack/react-query';

import { getKitProducts } from '@Api/Kits';
import { useRequest } from '@Contexts/Request';

import type { KitProductData } from '@Types/Kit';
import type { UseInfiniteQueryResult, InfiniteData } from '@tanstack/react-query';

export type Result = UseInfiniteQueryResult<InfiniteData<KitProductData>>;

const useInfiniteKitProducts = (id: number): Result => {
  const { region, country } = useRequest();
  const key = ['kit-products', id, region, country];

  const kitProducts = useInfiniteQuery({
    queryKey: key,
    queryFn: async ({ pageParam }) => {
      const kits = await getKitProducts(id, pageParam);

      return {
        ...kits,
        changedProducts: kits.products.map((product) => ({ ...product, quantity: 0 })),
      };
    },
    initialPageParam: 1,
    enabled: true,
    getNextPageParam: (lastPage) => {
      if (!lastPage) return null;

      const nextPageParam = lastPage.currentPage + 1;

      return lastPage.itemCountLeft === 0 ? null : nextPageParam;
    },
  });

  return kitProducts;
};

export default useInfiniteKitProducts;
